import axios from 'axios';
import { restManager } from '@/plugin/restManager.js';
import restBase from '@/plugin/restBase';
import util from './util';
import { useColumnSetting } from '@/composables/useColumnSettings';

const { clearAllColumnsSetting } = useColumnSetting('');

const loginBase = `${process.env.VUE_APP_REST_PROTOCOL}${process.env.VUE_APP_REST_DOMAIN}:${process.env.VUE_APP_REST_PORT}`;
let hash = (() => {
  var j, q;
  /* eslint-disable */
  q = window.location.hash.replace(/\#/, '').split('&');
  /* eslint-enable */
  j = {};
  q.forEach(function (item) {
    item = item.split('=');
    return (j[item[0]] = item[1]);
  });
  return j;
})();
let qs = (() => {
  if (location.search) {
    var search = location.search.substring(1);
    return JSON.parse(
      '{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}'
    );
  } else return null;
})();
const config = {
  axios,
  baseURL: '',
  successRedirectURL: ''
};

const validateSession = () => {
  return new Promise((resolve, reject) => {
    // if (qs && qs.code != null) {
    //   login(qs.code);
    //   reject('login..');
    // }
    // if (axios.defaults.headers.common['Authorization'] == null) {
    //   goToLogin();
    //   reject('gotologin..');
    // }

    resolve();
  });
};

const goToLogin = () => {
  let url =
    'https://console.kr-west1.dev1.samsungsdscloud.com/accounts/oidc/authorize?api=true&client_id=scpmapp&redirect_uri=http://localhost:8080/&response_type=code&scope=openid%20profile&state=af0ifjsldkj';

  const language = util.getLocale();
  if (url.includes('?')) {
    url += `&locale=${language}`;
  } else {
    url += `?locale=${language}`;
  }

  clearAllColumnsSetting();
  util.setWindowLocation(url);
};
const login = (code) => {
  return new Promise((resolve) => {
    let redirect_uri = 'http://localhost:8080/';
    let param = `grant_type=authorization_code&code=${encodeURIComponent(
      code
    )}&api=true&redirect_uri=${redirect_uri}`;
    restManager
      .post('http://localhost:8080/accounts/oidc/accessToken?api=true', param, true, false, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
      .then((data) => {
        //console.log('login data = ', data);
        restManager.setIdToken(data.id_token);
        location.href = '/';
        resolve();
      });
  });
};

const logout = () => {
  const url = `http://dev.samsungsdscloud.com/accounts/logout`;

  sessionStorage.clear();
  clearAllColumnsSetting();
  window.location.href = url;
};

export default {
  config,
  validateSession,
  goToLogin,
  login,
  logout
};
